import { QueryDtoOf } from '@40seas/entities/common';
import { CreditLineRequest } from './credit-line-request.entity';
import { Buyer } from '@40seas/entities/buyers';

export class QueryCreditLineRequestDto extends QueryDtoOf(CreditLineRequest, [Buyer]) {}
